
import { Component, Mixins, Emit } from "vue-property-decorator";
import Singlepages from "@/mixins/SinglepagesJa";
import PageHeader from "@/components/page/PageHeader.vue";

@Component({
  components: {
    PageHeader,
  },
})
export default class News extends Mixins(Singlepages) {
  private name = "news";
  private pageTitle1 = "NEWS";
  private pageTitle2 = "SPECIAL CONTENTS";
  private newentriesLabel = "新着ニュース";
}
